// --- Core ---
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
// --- SaniQ ---
import {Person} from "../../models/Person";

interface PeopleState {
  collection: Record<string, Person | boolean>
}

const initialState: PeopleState = {
  collection: {}
};

const peopleSlice = createSlice({
  // eslint-disable-next-line formatjs/no-literal-string-in-object
  name: 'people',
  initialState,
  reducers: {
    showPersonCompleted(state, action: PayloadAction<Person>) {
      if (state.collection[action.payload.id] === true) {
        state.collection = {...state.collection, [action.payload.id]: action.payload};
      }
    },
    showPersonFailed(state, action: PayloadAction<string>) {
      if (state.collection[action.payload] === true) {
        state.collection = {...state.collection, [action.payload]: false};
      }
    },
    showPersonStarted(state, action: PayloadAction<string>) {
      if (state.collection[action.payload] === undefined) {
        state.collection = {...state.collection, [action.payload]: true};
      }
    }
  }
});

export const {showPersonCompleted, showPersonFailed, showPersonStarted} = peopleSlice.actions;

export default peopleSlice.reducer;
